import { tw } from "@careinfo/tailwind";
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import { getApiData } from "../../helpers/AxiosInstance";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import Form from "./Form";
import { getKey } from "../../helpers/sessionKey";

const EditExpenseNote = (props: any) => {
  const { handleEdit, isLoading, data, handleMarkAsDone, isMarkasDoneloading } =
    props;

  const {
    setValue,
    getValues,
    setError,
    register,
    handleSubmit,
    watch,
    control,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: async () => {
      return {
        ...data,
      };
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const isSuperUser = getKey("is_superuser") === "true";

  return (
    <>
      <Card>
        <form
          className={tw``}
          onSubmit={handleSubmit((data) => handleEdit(data, setError))}
        >
          <Form
            errors={errors}
            register={register}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            fields={fields}
            watch={watch}
            isActive={data?.is_active}
            isSuperUser={isSuperUser}
            remove={remove}
            append={append}
          />
          <div className={tw`flex justify-end w-full gap-x-4 px-4`}>
            <div className={tw`w-24`}>
              <Button
                onClick={handleMarkAsDone}
                type="button"
                isLoading={isMarkasDoneloading}
                disabled={!isSuperUser && !data?.is_active}
                label={data?.is_active ? "Mark as Done" : "Revert"}
              />
            </div>
            <div className={tw`w-24`}>
              <Button
                label={"Update"}
                disabled={!data?.is_active}
                isLoading={isLoading}
              />
            </div>
          </div>
        </form>
      </Card>
    </>
  );
};

export default EditExpenseNote;
